import {ButtonWithDropdown} from "@cjdev-internal/visual-stack/lib/components/ButtonWithDropdown";
import DatePickerButton from "@cjdev-internal/visual-stack/lib/components/DatePicker/DatePickerButton";
import {
    DatePicker,
    sectionRange,
    sectionTitle,
    sidebarSection
} from "@cjdev-internal/visual-stack/lib/components/DatePicker";
import moment from "moment";
import React, {useState} from "react";
import {useCampaignsContext} from "../CampaignsContext/useCampaignsContext";
import * as appConstant from '../../constants/appConstant';
import "./styles/DateFilter.css";

export const DateFilter = () => {
    const [showDatePicker, setShowDatePicker] = useState(false)
    const {filterData, setFilterData} = useCampaignsContext();
    const {startDate, endDate, namedRange} = filterData.dateRange;
    const initialDateRange = [[startDate, endDate]]
    const [selectedRanges, setSelectedRanges] = useState(initialDateRange)
    const [selectedNamedRanges, setSelectedNamedRanges] = useState(namedRange);
    const generatePreDefinedOptions = () => {
        const formatDate = (date) => {
            if (date) {
                return date.format(appConstant.YYYY_MM_DD)
            }
        }
        const getDateRange = (dateRangeMode, dateRangeUnit) => {
            const date = moment();
            if (dateRangeMode === "last") {
                date.subtract(1, dateRangeUnit);
            } else if (dateRangeMode === "next") {
                date.add(1, dateRangeUnit);
            }
            const startDate = formatDate(date.startOf(dateRangeUnit));
            const endDate = formatDate(date.endOf(dateRangeUnit));
            return [startDate, endDate];
        }

        const today = formatDate(moment());
        const yesterday = formatDate(moment().subtract(1, "day"));

        const preDefinedOptions = [
            {key: "today", label: appConstant.TODAY, range: [today, today]},
            {key: "yesterday", label: appConstant.YESTERDAY, range: [yesterday, yesterday]},
            {key: "thisWeek", label: appConstant.THIS_WEEK, range: getDateRange("current", "week")},
            {key: "lastWeek", label: appConstant.LAST_WEEK, range: getDateRange("last", "week")},
            {key: "thisMonth", label: appConstant.THIS_MONTH, range: getDateRange("current", "month")},
            {key: "lastMonth", label: appConstant.LAST_MONTH, range: getDateRange("last", "month")},
            {key: "nextQuarter", label: appConstant.NEXT_QUARTER, range: getDateRange("next", "quarter")},
            {key: "thisQuarter", label: appConstant.THIS_QUARTER, range: getDateRange("current", "quarter")},
            {key: "lastQuarter", label: appConstant.LAST_QUARTER, range: getDateRange("last", "quarter")},
            {key: "thisYear", label: appConstant.THIS_YEAR, range: getDateRange("current", "year")},
            {key: "lastYear", label: appConstant.LAST_YEAR, range: getDateRange("last", "year")},
            {key: "custom", label: appConstant.CUSTOM, range: null}
        ]
        return preDefinedOptions;
    }


    const onApply = (ranges, namedRanges) => {
        setShowDatePicker(false)
        const dateRange = {
            startDate: ranges[0][0],
            endDate: ranges[0][1],
            namedRange: namedRanges
        }
        const filterDataWithRange = {
            ...filterData,
            dateRange: dateRange
        }
        setFilterData(filterDataWithRange);
    }
    const onCancel = () => {
        setSelectedRanges(initialDateRange);
        setSelectedNamedRanges(namedRange);
        setShowDatePicker(false);
    }

    const getSideBarConfig = () => {

        const preDefinedOptions = generatePreDefinedOptions();
        const listOfSectionRange = preDefinedOptions.map((option) => sectionRange(option.key, option.label, option.range));

        return [
            sidebarSection(
                sectionTitle(appConstant.PREDEFINED_RANGES_LABEL),
                ...listOfSectionRange
            )
        ]
    }
    const sideBarConfig = getSideBarConfig();
    const selectableRangeStartDate = appConstant.DATE_FILTER_START_DATE;
    const selectableRangeEndDate = moment().add(1, "year").endOf('year').format(appConstant.YYYY_MM_DD);
    const selectableRange = [selectableRangeStartDate, selectableRangeEndDate];

    return (
        <ButtonWithDropdown
            id={"date-filter-button"}
            renderButton={props => (
                <DatePickerButton
                    id={"date-filter-picker-button"}
                    ranges={selectedRanges}
                    locale={"en"}
                    {...props}
                />
            )}
            expanded={showDatePicker}
            doExpand={() => {
                setShowDatePicker(prevState => !prevState)
            }}
        >
            <DatePicker
                id={"date-picker"}
                selectedRanges={selectedRanges}
                updateCalendarRanges={setSelectedRanges}
                selectedNamedRanges={selectedNamedRanges}
                updateNamedCalendarRanges={setSelectedNamedRanges}
                applyButtonText={appConstant.DATE_FILTER_APPLY}
                onApply={onApply}
                cancelButtonText={appConstant.DATE_FILTER_CANCEL}
                onCancel={onCancel}
                selectableRange={selectableRange}
                locale={appConstant.NO_LOCALE}
                sidebarConfig={sideBarConfig}
            />
        </ButtonWithDropdown>
    )
}